import { z } from 'zod';
import { QcStatus, SourceSystem } from '../enums.js';
import { IsoDate, IsoDateTime, UuidString } from '../primitives.js';

/** Batch (партия). */
export const Batch = z.object({
  id: UuidString,
  entity_id: UuidString,
  batch_no: z.string().min(1),
  item_id: UuidString,
  // FE-208 Pass 96: BE-shipped denorm fields (handler does inArray-JOIN на items).
  item_name: z.string().nullable().optional(),
  item_sku: z.string().nullable().optional(),
  mfg_date: IsoDate.nullable(),
  expiry_date: IsoDate.nullable(),
  qc_status: QcStatus.default('pending'),
  source_system: SourceSystem,
  source_document_id: z.string().nullable(),
  source_system_ref: z.record(z.unknown()).nullable(),
  fetched_at: IsoDateTime.nullable(),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type Batch = z.infer<typeof Batch>;
